var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.header},[(_vm.icon)?_c('div',{class:_vm.$style.iconContainer,style:({
      backgroundColor: _vm.iconBackgroundColor,
      color: _vm.iconColor,
    })},[_c('FontAwesomeIcon',{attrs:{"fixed-width":"","icon":_vm.icon,"size":_vm.size}})],1):_vm._e(),_vm._v(" "),_c('h3',{class:_vm.$style.title},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }